var $ = require('jquery');
var MobileDetect = require('mobile-detect');

$(function () {
    function wrapYoutubeIframe($target, os) {
      if (!$target.length) {
          return;
      }
      var re = new RegExp(/^https?:\/\/(www\.)?youtube.com\/embed\/([a-zA-Z0-9]+)/),
          src = $target.attr('src'),
          code;
        if (!re.test(src) || src.match(re).length < 3) {
            return;
        }
        if (os != 'AndroidOS' && os != 'iOS') {
            return;
        }
        code = src.match(re)[2];
        var href = '';
        if (os == 'AndroidOS') {
            href = 'https://www.youtube.com/watch?v=' + code;
        } else if (os == 'iOS') {
            href = 'youtube://youtube.com/v/' + code;
        }
        $target.wrap('<a href="'+ href + '" class="youtube-wrap"><div class="overlay-wrapper"><div class="iframe-video"></div></div></a>');
    };


    $('form.news-search select[name="team"]').change(function(e) {
        e.preventDefault();
        $(this).parents('form').submit();
    });
    $('.sidebar .button').click(function() {
        $(this).siblings().removeClass('checked');
        $(this).addClass('checked');
        $(this).parent().siblings().removeClass('active');
        $(this).parent().siblings('.' + $(this).data('list')).addClass('active');
    });

    $('#popularity-select select').on('change', function () {
        $('#popularity-select').submit();
    });

    var os = new MobileDetect(window.navigator.userAgent).os(),
        $target = $('.news-text iframe.video-360').first();
    wrapYoutubeIframe($target, os);
});
readActLang = function(name){
    var cookies = document.cookie.split(';')
    for(var i = 0; i<cookies.length; i++){
        if(cookies[i].includes(name)){
            return cookies[i].split("=")[1]
        }
    }
}



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/site/js/news.js
// module id = 9
// module chunks = 0